import script from "./AlertPayloadDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertPayloadDetails.vue?vue&type=script&setup=true&lang=js"

import "./AlertPayloadDetails.vue?vue&type=style&index=0&id=ece0310c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece0310c"]])

export default __exports__